import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EncontroPage } from '../encontro/encontro.page';
import { EventoProvider } from 'src/app/services/evento/evento';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { ImagePipe } from 'src/app/pipes/image/image';
@Component({
  selector: 'app-encontros-passados',
  templateUrl: './encontros-passados.page.html',
  styleUrls: ['./encontros-passados.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SemRegistroComponent,
    ImagePipe
  ],
})
export class EncontrosPassadosPage implements OnInit {
  encontros: any = [];
  evento: any;
  isEnsino = false;
  inscricao_avulsa = false;
  loaded = false;
  isEncontro;
  tipoEvento: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public eventoProvider: EventoProvider,
    public loadingController: LoadingController,
    private translate: TranslateService,
    private modalCtrl: ModalController,
  ) {
    this.evento = this.navParams.get('evento');
    this.encontros = this.navParams.get('encontros');
    this.isEnsino = this.navParams.get('isEnsino');
    this.isEncontro = this.navParams.get('isEncontro');
    this.inscricao_avulsa = this.navParams.get('inscricao_avulsa');
    this.tipoEvento = this.navParams.get('tipoEvento');
  }

  ngOnInit() { }

  async openEncontro(encontro: any) {
    var data = {
      encontro: encontro,
      isEnsino: this.isEnsino,
      isAdmin: this.evento.isAdmin,
      responsaveis: this.evento.responsaveis,
      isAvulso: this.inscricao_avulsa,
      checkInAntecipado: this.evento.configuracao.checkInAntecipado,
      tipoEvento: this.tipoEvento,
    };
    const modalPage = await this.modalCtrl.create({ component: EncontroPage, componentProps: data });
    modalPage.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
